module.exports = "https://r.nearpod.com/assets/media/image/subplan-icon-8995f5e0504885dcf602e79efdc038a7.svg";